/* @jsx h */
import { User } from "@lemmonhq/types";
import { defineComponent, onMounted, h } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuth } from "../providers";
import { LandingPage } from "./Landing";

export type ColleagueProfile = { id: number; name: string };
export const HomePage = defineComponent({
  name: "HomePage",
  setup() {
    const auth = useAuth();
    const router = useRouter();

    // New state for PIN login feature

    const route = useRoute();

    const redirect = (user: User) => {
      const qs = new URLSearchParams(
        (route.query as Record<string, string>) || {},
      ).toString();
      if (user.role === "staff") {
        return router.replace(`/app/pos?${qs}`);
      } else if (user.role === "manager") {
        return router.replace(`/app/reports?${qs}`);
      } else if (user.role === "admin") {
        return router.replace(`/app/admin/dashboard?${qs}`);
      }
    };

    onMounted(async () => {
      if (!auth.user.value) {
      } else {
        return redirect(auth.user.value);
      }
    });

    return () => {
      return <LandingPage />;
    };
  },
});
